/* assets/src/viewer/core/loop.js
 * Render loop ON-DEMAND (port :925-2966 della logica animate + :153-177).
 * Renderizza solo quando qualcosa cambia o i controlli si muovono/smorzano.
 */
import { isMobileViewer } from '../settings.js';

export class RenderLoop {
  constructor(viewer) {
    this.viewer = viewer;
    this.renderRequested = true;
    this.shadowUpdateRequested = true;
    this.lastRenderTime = 0;
    this.mobileFlip = false;
    this._raf = 0;
    this._tick = this._tick.bind(this);
  }

  // invalidate completo (geometria + ombre)
  requestRender() {
    this.renderRequested = true;
    this.shadowUpdateRequested = true;
  }

  // invalidate solo vista (movimento camera): non forza l'aggiornamento ombre
  requestViewRender() {
    this.renderRequested = true;
  }

  start() {
    if (!this._raf) this._tick(0);
  }

  stop() {
    if (this._raf) {
      cancelAnimationFrame(this._raf);
      this._raf = 0;
    }
  }

  renderFrame() {
    const v = this.viewer;
    const renderer = v.renderer;
    if (!renderer || !v.scene || !v.camera || document.hidden) return;
    this.renderRequested = false;
    if (renderer.shadowMap && renderer.shadowMap.enabled) {
      renderer.shadowMap.needsUpdate = !!this.shadowUpdateRequested;
      this.shadowUpdateRequested = false;
    }
    renderer.clear();
    renderer.setViewport(0, 0, renderer.domElement.clientWidth, renderer.domElement.clientHeight);
    renderer.render(v.scene, v.camera);
    if (v.gizmo && v.gizmo.render) v.gizmo.render(v.camera);
  }

  _tick(time = 0) {
    this._raf = requestAnimationFrame(this._tick);
    if (document.hidden) return;

    const v = this.viewer;
    const mobile = isMobileViewer();
    const controlsChanged = v.controls ? !!v.controls.update() : false;
    const isAutoRotating = !!(v.controls && v.controls.autoRotate);
    const isAnimated = v.stepAnimations ? !!v.stepAnimations(time) : false;

    if (!v.renderer || !v.scene || !v.camera) return;

    const shouldRender = this.renderRequested || controlsChanged || isAnimated || isAutoRotating;
    if (!shouldRender) return;

    // Durante interazione/animazione renderizza OGNI frame (gap 0): nessun frame saltato che il browser
    // possa comporre come buffer stantio/pulito -> niente flicker/flash quando si muove la vista
    // (importante sui monitor ad alta frequenza, dove un throttle a 16ms salterebbe dei frame).
    const minFrameGap = (controlsChanged || isAnimated) ? 0 : (mobile ? 64 : (isAutoRotating ? 33 : 24));
    if (time && this.lastRenderTime && time - this.lastRenderTime < minFrameGap) return;
    this.lastRenderTime = time || performance.now();

    if (mobile) {
      this.mobileFlip = !this.mobileFlip;
      if (this.mobileFlip && !this.renderRequested && !controlsChanged) return;
    }

    this.renderFrame();
  }
}
